/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchWACampaignData = createAsyncThunk('fetchWACampaignData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget(`api/whatsapp/campaigns`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const WAcampaignSlice = createSlice({
    name: 'WAcampaignDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWACampaignData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchWACampaignData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchWACampaignData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default WAcampaignSlice.reducer;